export interface ReportEvaluation {
    id: number;
    expired: boolean;
    boardingResult: ReportEvaluationResult;
    daycareResult: ReportEvaluationResult;
    groomingResult: ReportEvaluationResult;
}

export enum ReportEvaluationResult {
    FAIL = 'fail',
    PASS = 'pass'
}
